import { Map } from 'immutable';
import { buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import RAv2HomeworkResultSummary from './model';

const method = 'GET';
const buildRAv2HomeworkResultSummaryUrl = (groupId) =>
  buildUrl(`/ra-v2-groups/${groupId}/homework-result-summary`);

export function getRAv2HomeworkResultSummaryByGroup(state, groupId) {
  const summariesByGroup = state
    .get('rootReducer')
    .get('rav2HomeworkResultSummary');

  if (! summariesByGroup || ! Map.isMap(summariesByGroup)) {
    return new Map({});
  }

  return summariesByGroup.get(groupId) || new Map({});
}

export function getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId) {
  if (! studentId) {
    return RAv2HomeworkResultSummary.create();
  }

  const groupSummary = getRAv2HomeworkResultSummaryByGroup(state, groupId);
  return groupSummary.get(`${studentId}`) || RAv2HomeworkResultSummary.create({ studentId });
}

export function getStudentAvgCompletion(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).avgCompletion || 0;
}

export function getStudentAvgAccuracy(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).avgAccuracy || 0;
}

export function getStudentTotalRecorded(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).totalRecorded || 0;
}

export function getStudentTotalStoryRead(state, groupId, studentId) {
  return getRAv2HomeworkResultSummaryByStudent(state, groupId, studentId).totalStoryRead || 0;
}

export function isLoadingRAv2HomeworkResultSummary(state, groupId) {
  const callState = ApiCall.find(state, {
    method,
    url: buildRAv2HomeworkResultSummaryUrl(groupId),
  });

  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultSummary/accessors.js